import { render, staticRenderFns } from "./ttshop_mycollection.vue?vue&type=template&id=5f6f2fcb&scoped=true&"
import script from "./ttshop_mycollection.vue?vue&type=script&lang=js&"
export * from "./ttshop_mycollection.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_mycollection.vue?vue&type=style&index=0&id=5f6f2fcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6f2fcb",
  null
  
)

export default component.exports